







import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class AnxTableRow extends Vue {
  /** The columns for the row */
  @Prop({ default: null }) item!: Record<string, string> | null;
}
